/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

/*
 * Show toast notifacation
 */

var Model = require("../types/Model.js");

var DISPLAY_TIME = 5000; // 5 seconds

module.exports = Model({
	name: "toast",
	init: init,
	uninit: uninit,
	triggers: triggers,

	_called_queue: null,
	_to_hide: null,

	show: show,
	hide: hide,
});

function init() {
	this._called_queue = []; // initialize queue
	this.push(null); // Push an null as the initial state
}

function uninit() {
	this._called_queue = null;
	clearTimeout(this._to_hide);
}

function triggers() {
	return {
		"show": show,
		"hide": hide,
	};
}

function show(toast) {
	var currentlyShowing = this.data;

	if(!currentlyShowing || toast.immediate){
		this.push(toast);
		clearTimeout(this._to_hide);
		this._to_hide = setTimeout(hide.bind(this), DISPLAY_TIME);
	} else {
		this._called_queue.push(toast);
	}
}

function hide() {
	this.push(null);
	clearTimeout(this._to_hide);
	if(!this._called_queue.length) return;

	var data = this._called_queue.shift();
	this.show(data);
}
